//https://blog.logrocket.com/simplify-react-state-management-with-hookstate/
import { hookstate } from '@hookstate/core'


export const initialState = {
        idToken: null,
        accessToken: null,
        idTokenClaims:null
}

const globalAuthStateStore = hookstate(initialState);

export default globalAuthStateStore;